import script from "./HumanComputerInteractionView.vue?vue&type=script&setup=true&lang=js"
export * from "./HumanComputerInteractionView.vue?vue&type=script&setup=true&lang=js"

import "./HumanComputerInteractionView.vue?vue&type=style&index=0&id=8c4bc9b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c4bc9b4"]])

export default __exports__